import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";

import { ThemeProvider }    from "./context/ThemeContext";
import { AuthProvider }     from "./context/AuthContext";
import { DarkModeProvider } from "./context/DarkModeContext";

import Landing            from "./pages/Landing";
import Login              from "./pages/Login";
import PendingVerification from "./pages/PendingVerification";
import UserDashboard      from "./pages/UserDashboard";
import AdminDashboard     from "./pages/AdminDashboard";
import AdminCommander     from "./pages/AdminCommander";
import ForgotPassword     from "./pages/ForgotPassword";
import ResetPassword      from "./pages/ResetPassword";
import InvestorDashboard  from "./pages/InvestorDashboard";
import ApplyInvestor      from "./pages/ApplyInvestor";
import AffiliateDashboard from "./pages/AffiliateDashboard";
import ICEMan             from "./pages/ICEMan";
import ProtectedRoute     from "./components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <DarkModeProvider>
          <BrowserRouter>
            <AuthProvider>
              <Routes>
                {/* ── Public ── */}
                <Route path="/"                element={<Landing />} />
                <Route path="/login"           element={<Login adminMode={false} />} />
                <Route path="/admin/login"     element={<Login adminMode={true} />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password"  element={<ResetPassword />} />
                <Route path="/apply-partner"   element={<ApplyInvestor />} />
                <Route path="/apply-investor"  element={<ApplyInvestor />} />
                <Route path="/iceman"          element={<ICEMan />} />
                <Route path="/pending"         element={<PendingVerification />} />

                {/* ── client ONLY — must be approved by admin ── */}
                <Route path="/dashboard"
                  element={<ProtectedRoute roles={["client"]}><UserDashboard /></ProtectedRoute>} />

                {/* ── investor ── */}
                <Route path="/partner"
                  element={<ProtectedRoute roles={["investor"]}><InvestorDashboard /></ProtectedRoute>} />
                <Route path="/investor"
                  element={<ProtectedRoute roles={["investor"]}><InvestorDashboard /></ProtectedRoute>} />

                {/* ── admin ── */}
                <Route path="/admin"
                  element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
                <Route path="/commander/admin"
                  element={<ProtectedRoute adminOnly><AdminCommander /></ProtectedRoute>} />

                {/* ── affiliate ── */}
                <Route path="/commander/affiliate"
                  element={<ProtectedRoute roles={["affiliate"]}><AffiliateDashboard /></ProtectedRoute>} />
              </Routes>
              <Toaster theme="dark" position="top-right" />
            </AuthProvider>
          </BrowserRouter>
        </DarkModeProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
